import { useCallback, useState } from 'react';

const readValue = (key, initialValue) => {
  if (typeof window === 'undefined') return initialValue;

  try {
    const storedValue = window.localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : initialValue;
  } catch (error) {
    return initialValue;
  }
};

const useLocalStorage = (key, initialValue) => {
  const [value, setValue] = useState(() => readValue(key, initialValue));

  const setStoredValue = useCallback(nextValue => {
    setValue(currentValue => {
      const resolvedValue = typeof nextValue === 'function'
        ? nextValue(currentValue)
        : nextValue;

      if (typeof window !== 'undefined') {
        try {
          window.localStorage.setItem(key, JSON.stringify(resolvedValue));
        } catch (error) {
          // Storage can be unavailable in private browsing or restricted environments.
        }
      }

      return resolvedValue;
    });
  }, [key]);

  const removeStoredValue = useCallback(() => {
    setValue(initialValue);

    if (typeof window !== 'undefined') {
      window.localStorage.removeItem(key);
    }
  }, [initialValue, key]);

  return [value, setStoredValue, removeStoredValue];
};

export default useLocalStorage;
